"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocCache = void 0;
const lru_map_1 = require("lru_map");
class DocCache {
    constructor(limit, cacheCommits = true) {
        this._cacheCommits = cacheCommits;
        this._baseDocCache = new lru_map_1.LRUMap(limit);
        this._pinnedDocCache = {};
        this._commitDocCache = this._cacheCommits ? new lru_map_1.LRUMap(limit) : null;
    }
    put(doc) {
        if (doc.id.commit == null) {
            this._baseDocCache.set(doc.id.baseID.toString(), doc);
            return;
        }
        if (this._cacheCommits) {
            this._commitDocCache.set(doc.id.toString(), doc);
        }
    }
    get(docId) {
        let doc = this._pinnedDocCache[docId.toString()];
        if (doc) {
            return doc;
        }
        doc = this._baseDocCache.get(docId.toString());
        if (doc) {
            return doc;
        }
        return this._cacheCommits ? this._commitDocCache.get(docId.toString()) : null;
    }
    pin(doc) {
        if (doc.id.commit != null) {
            throw new Error(`Cannot pin a specific commit. Doc ID ${doc.id.toString()}`);
        }
        this._pinnedDocCache[doc.id.toString()] = doc;
        this._baseDocCache.delete(doc.id.toString());
    }
    unpin(docId) {
        const doc = this._pinnedDocCache[docId.baseID.toString()];
        delete this._pinnedDocCache[docId.baseID.toString()];
        if (doc) {
            this.put(doc);
        }
        return;
    }
    del(docId) {
        this._baseDocCache.delete(docId.baseID.toString());
        if (this._cacheCommits) {
            this._commitDocCache.delete(docId.toString());
        }
    }
    has(docId) {
        return this.get(docId) != null;
    }
    applyToAll(applyFn) {
        this._baseDocCache.forEach((d) => applyFn(d));
        if (this._cacheCommits) {
            this._commitDocCache.forEach((d) => applyFn(d));
        }
        Object.entries(this._pinnedDocCache).forEach(([, d]) => applyFn(d));
    }
    clear() {
        this._pinnedDocCache = {};
        this._baseDocCache.clear();
        if (this._cacheCommits) {
            this._commitDocCache.clear();
        }
    }
}
exports.DocCache = DocCache;
//# sourceMappingURL=doc-cache.js.map